import logger from "@logger";
import QUERY_KEYS from "@shared/queryKeys";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { requestAccountDeletion } from "../services/accountDeletionService";

export function useRequestAccountDeletion() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => requestAccountDeletion(),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.CURRENT_USER] });
    },
    onError: (error) => {
      logger.error("Failed to request account deletion:", error);
    },
  });
}
